module.exports = __webpack_public_path__ + "img/logo-molkky.55a5a661.png";